module.exports = __webpack_public_path__ + "static/media/Solero-JPG-Image-10-ct-Cream-Pops-Coconut-and-Banana-Cinn.a497001d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/Solero-JPG-Image-10-ct-Cream-Pops-Coconut-and-Banana-Cinn.jpg
// module id = 176
// module chunks = 0